import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import dedent from 'dedent';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmVideoConfig, { McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';

const McmPackageLuxury: TenantPackageConfig<McmOrderContext> = {
  id: 'luxury',
  name: 'Luxury',
  performables: [
    McmPhotoConfig,
    {
      config: McmVideoConfig,
      metadata: {
        type: McmVideoType.LUXURY,
        day_to_night: true,
        social_edit: true,
      },
    },
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.VIDEO_PHOTO
      },
    },
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.PHOTO,
        twilight: true
      },
    },
  ],
  eligible: ({ buyer, parent }) => !Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '',
  amount: '449.85',
};

export default McmPackageLuxury;
